export function assurantHomeWarrantyOrderFormandWaiverBuyer() {
return [   // Release 2026-01-15 10:41:02
 
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.197,
   left: 151.803,
   width: 393.054,
   height: 13.273
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 169.896,
   left: 137.621,
   width: 407.017,
   height: 13.273
}
,
{
   page: 0,
   name: "Checkbox I understand", 
   isText: false,
   type: "checkbox",
   top: 493.646,
   left: 66.2874,
   width: 9.8183,
   height: 9.491
}
,
{
   page: 0,
   name: "Checkbox I have been informed", 
   isText: false,
   type: "checkbox",
   top: 510.233,
   left: 66.0257,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 0,
   name: "Radiobutton Accept yes", 
   isText: false,
   type: "checkbox",
   top: 565.81,
   left: 66.0257,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Accept No", 
   isText: false,
   type: "checkbox",
   top: 583.119,
   left: 66.0257,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box15", 
   isText: false,
   type: "checkbox",
   top: 87.637,
   left: 279.837,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box16", 
   isText: false,
   type: "checkbox",
   top: 87.637,
   left: 357.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box17", 
   isText: false,
   type: "checkbox",
   top: 87.637,
   left: 434.311,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box18", 
   isText: false,
   type: "checkbox",
   top: 87.637,
   left: 517.439,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box19", 
   isText: false,
   type: "checkbox",
   top: 106.619,
   left: 279.837,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box20", 
   isText: false,
   type: "checkbox",
   top: 106.619,
   left: 357.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box21", 
   isText: false,
   type: "checkbox",
   top: 106.619,
   left: 434.311,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box22", 
   isText: false,
   type: "checkbox",
   top: 106.619,
   left: 517.439,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box23", 
   isText: false,
   type: "checkbox",
   top: 124.946,
   left: 357.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box24", 
   isText: false,
   type: "checkbox",
   top: 125.601,
   left: 434.311,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box25", 
   isText: false,
   type: "checkbox",
   top: 125.601,
   left: 517.439,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box26", 
   isText: false,
   type: "checkbox",
   top: 145.237,
   left: 357.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box27", 
   isText: false,
   type: "checkbox",
   top: 144.583,
   left: 434.311,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box28", 
   isText: false,
   type: "checkbox",
   top: 144.583,
   left: 517.439,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box29", 
   isText: false,
   type: "checkbox",
   top: 185.819,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box30", 
   isText: false,
   type: "checkbox",
   top: 205.801,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box31", 
   isText: false,
   type: "checkbox",
   top: 223.129,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box32", 
   isText: false,
   type: "checkbox",
   top: 238.183,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box33", 
   isText: false,
   type: "checkbox",
   top: 253.892,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box34", 
   isText: false,
   type: "checkbox",
   top: 270.256,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box35", 
   isText: false,
   type: "checkbox",
   top: 285.965,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box36", 
   isText: false,
   type: "checkbox",
   top: 302.983,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box37", 
   isText: false,
   type: "checkbox",
   top: 319.347,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box38", 
   isText: false,
   type: "checkbox",
   top: 336.056,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box39", 
   isText: false,
   type: "checkbox",
   top: 352.075,
   left: 356.729,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box40", 
   isText: false,
   type: "checkbox",
   top: 185.819,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box41", 
   isText: false,
   type: "checkbox",
   top: 205.456,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box42", 
   isText: false,
   type: "checkbox",
   top: 222.474,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box43", 
   isText: false,
   type: "checkbox",
   top: 238.183,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box44", 
   isText: false,
   type: "checkbox",
   top: 253.892,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box45", 
   isText: false,
   type: "checkbox",
   top: 270.256,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box46", 
   isText: false,
   type: "checkbox",
   top: 286.62,
   left: 491.566,
   width: 10.080,
   height: 10.08
}
,
{
   page: 2,
   name: "Check Box47", 
   isText: false,
   type: "checkbox",
   top: 302.983,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box48", 
   isText: false,
   type: "checkbox",
   top: 319.347,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box49", 
   isText: false,
   type: "checkbox",
   top: 336.056,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box50", 
   isText: false,
   type: "checkbox",
   top: 352.075,
   left: 491.566,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Address Full 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 440.93,
   left: 34.3818,
   width: 271.0912,
   height: 11.527
}
,
{
   page: 2,
   name: "Address City", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 466.148,
   left: 32.4182,
   width: 149.9998,
   height: 10.872
}
,
{
   page: 2,
   name: "Address State", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 466.148,
   left: 186.31,
   width: 40.036,
   height: 10.872
}
,
{
   page: 2,
   name: "Address Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 466.148,
   left: 231.419,
   width: 73.418,
   height: 10.872
}
,
{
   page: 2,
   name: "Sqft", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 490.057,
   left: 32.4182,
   width: 110.0728,
   height: 10.873
}
,
{
   page: 2,
   name: "TextDate Listing Expire Date", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 490.366,
   left: 171.837,
   width: 133.636,
   height: 10.218
}
,
{
   page: 2,
   name: "Seller 1 First Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 533.257,
   left: 33.0728,
   width: 137.5632,
   height: 10.873
}
,
{
   page: 2,
   name: "Seller 1 Last Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 533.257,
   left: 175.11,
   width: 129.709,
   height: 10.873
}
,
{
   page: 2,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 556.821,
   left: 32.4182,
   width: 93.7088,
   height: 10.873
}
,
{
   page: 2,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 556.821,
   left: 138.455,
   width: 168.982,
   height: 10.873
}
,
{
   page: 2,
   name: "Seller 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 579.385,
   left: 33.0728,
   width: 275.0182,
   height: 10.872
}
,
{
   page: 2,
   name: "Buyer 1 First Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 620.621,
   left: 33.0728,
   width: 137.5632,
   height: 10.873
}
,
{
   page: 2,
   name: "Buyer 1 Last Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 620.621,
   left: 175.11,
   width: 129.709,
   height: 10.873
}
,
{
   page: 2,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 644.185,
   left: 32.4182,
   width: 93.7088,
   height: 10.873
}
,
{
   page: 2,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 644.185,
   left: 139.764,
   width: 167.673,
   height: 10.873
}
,
{
   page: 2,
   name: "Buyer 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 669.058,
   left: 33.0728,
   width: 275.0182,
   height: 10.872
}
,
{
   page: 2,
   name: "Amount Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 699.8216,
   left: 222.892,
   width: 55.090,
   height: 11.5272
}
,
{
   page: 2,
   name: "Amount Additional", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 713.567,
   left: 222.892,
   width: 55.090,
   height: 11.5273
}
,
{
   page: 2,
   name: "Amount Option", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 726.0034,
   left: 222.892,
   width: 55.090,
   height: 11.5273
}
,
{
   page: 2,
   name: "CALCULATE Amount Price PLUS Amount Additional PLUS Amount Option", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 739.749,
   left: 222.892,
   width: 55.090,
   height: 11.5272
}
,
{
   page: 2,
   name: "Title Company Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 442.584,
   left: 318.456,
   width: 189.516,
   height: 10.873
}
,
{
   page: 2,
   name: "Title Company Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 442.859,
   left: 510.238,
   width: 80.618,
   height: 10.872
}
,
{
   page: 2,
   name: "Title Company Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 469.111,
   left: 318.456,
   width: 206.981,
   height: 10.873
}
,
{
   page: 2,
   name: "Title Company Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 469.111,
   left: 528.577,
   width: 62.279,
   height: 10.873
}
,
{
   page: 2,
   name: "Title Company Address City", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 493.33,
   left: 318.456,
   width: 150.000,
   height: 10.872
}
,
{
   page: 2,
   name: "Title Company Address State", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 493.33,
   left: 469.693,
   width: 40.036,
   height: 10.872
}
,
{
   page: 2,
   name: "Title Company Address Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 493.33,
   left: 514.318,
   width: 76.538,
   height: 10.872
}
,
{
   page: 2,
   name: "Closing Date Text", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 516.239,
   left: 317.147,
   width: 135.600,
   height: 10.218
}
,
{
   page: 2,
   name: "Title Closing Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 516.239,
   left: 453.293,
   width: 137.563,
   height: 10.218
}
,
{
   page: 2,
   name: "Title Company Representative Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 541.421,
   left: 319.765,
   width: 271.091,
   height: 11.527
}
,
{
   page: 2,
   name: "Title Company Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 568.877,
   left: 319.765,
   width: 271.091,
   height: 10.219
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 625.858,
   left: 318.456,
   width: 197.489,
   height: 10.872
}
,
{
   page: 2,
   name: "Client Agent Brokerage Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 625.478,
   left: 518.243,
   width: 72.613,
   height: 10.872
}
,
{
   page: 2,
   name: "Agent Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 650.73,
   left: 319.765,
   width: 271.091,
   height: 11.528
}
,
{
   page: 2,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 676.258,
   left: 319.765,
   width: 271.091,
   height: 11.527
}
,
{
   page: 2,
   name: "Agent Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 699.6753,
   left: 317.147,
   width: 86.928,
   height: 11.6735
}
,
{
   page: 2,
   name: "Agent Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 699.0207,
   left: 408.699,
   width: 182.157,
   height: 12.3281
}
,
{
   page: 2,
   name: "Radiobutton AgentInitiatingRepresents Buyer", 
   isText: false,
   type: "checkbox",
   top: 608.003,
   left: 497.802,
   width: 11.389,
   height: 10.735
}
,
{
   page: 2,
   name: "Radiobutton AgentInitiatingRepresents Seller", 
   isText: false,
   type: "checkbox",
   top: 608.003,
   left: 544.584,
   width: 11.389,
   height: 10.735
}
] }
